import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { ClinusLaudo, ClinusPaciente } from '@/types/api';

/**
 * Cadastro do paciente (Clinus).
 * PROMPT 06: auth via cookie httpOnly.
 */
export function usePaciente(
  cdPaciente: number | null,
): UseQueryResult<ClinusPaciente, Error> {
  return useQuery({
    queryKey: ['paciente', cdPaciente],
    queryFn: ({ signal }) =>
      api.get<ClinusPaciente>(`/api/pacientes/${cdPaciente}`, { signal }),
    enabled: !!cdPaciente,
    staleTime: 60 * 60 * 1000, // 1h
  });
}

/**
 * Laudo (texto + URL PDF).
 */
export function useLaudo(
  cdLaudo: number | null,
): UseQueryResult<ClinusLaudo, Error> {
  return useQuery({
    queryKey: ['laudo', cdLaudo],
    queryFn: ({ signal }) =>
      api.get<ClinusLaudo>(`/api/laudos/${cdLaudo}`, { signal }),
    enabled: !!cdLaudo,
    staleTime: 24 * 60 * 60 * 1000,
  });
}
